<div class="main-container">
  <form [formGroup]="userProfileForm" novalidate>
    <!-- Component Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">User Profile</span>
      </div>
    </div>

    <!-- Component Body Section -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">User Details</h6>
        <div class="component-actions"></div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <form [formGroup]="userProfileForm" novalidate>
        <div class="flex-body">
          <div class="image-section">
            @if (!myimage) {
              <div>
                <img
                  loading="lazy"
                  src="../../assets/profile.png"
                  alt="Profile Picture"
                />
              </div>
            }
            @if (myimage) {
              <div>
                <img loading="lazy" [src]="myimage" alt="Profile Picture" />
              </div>
            }
            <input
              #fileUpload
              type="file"
              accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
              style="display: none"
              (change)="onChange($event)"
            />
            <button type="button" (click)="fileUpload.click()">
              Upload Profile Icon
            </button>
            <button type="button" (click)="changePass()">
              Change Password
            </button>
          </div>
          <div class="image-form-section">
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>Admin Name</mat-label>
                <input
                  matInput
                  formControlName="adminName"
                  placeholder="Admin Name"
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>First Name</mat-label>
                <input
                  matInput
                  formControlName="firstName"
                  placeholder="First Name"
                  required
                />
                @if (
                  userProfileForm.controls['firstName'].touched &&
                  userProfileForm.controls['firstName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['firstName'].touched &&
                        userProfileForm.controls['firstName'].errors
                          ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  userProfileForm.controls['firstName'].touched &&
                  userProfileForm.controls['firstName'].errors
                    ?.nonNumericNoSpecialChars
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['firstName'].touched &&
                        userProfileForm.controls['firstName'].errors
                          ?.nonNumericNoSpecialChars
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>Last Name</mat-label>
                <input
                  matInput
                  formControlName="lastName"
                  placeholder="Last Name"
                  required
                />
                @if (
                  userProfileForm.controls['lastName'].touched &&
                  userProfileForm.controls['lastName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['lastName'].touched &&
                        userProfileForm.controls['lastName'].errors
                          ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  userProfileForm.controls['lastName'].touched &&
                  userProfileForm.controls['lastName'].errors
                    ?.nonNumericNoSpecialChars
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['lastName'].touched &&
                        userProfileForm.controls['lastName'].errors
                          ?.nonNumericNoSpecialChars
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="email"
                  placeholder="User Email"
                  formControlName="userEmail"
                  required
                />
                @if (
                  userProfileForm.controls['userEmail'].touched &&
                  userProfileForm.controls['userEmail'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['userEmail'].touched &&
                        userProfileForm.controls['userEmail'].errors
                          ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  userProfileForm.controls['userEmail'].touched &&
                  userProfileForm.controls['userEmail'].errors?.validEmail
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['userEmail'].touched &&
                        userProfileForm.controls['userEmail'].errors?.validEmail
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input
                  matInput
                  type="email"
                  placeholder="Mobile Number"
                  formControlName="mobileNumber"
                  required
                />
                @if (
                  userProfileForm.controls['mobileNumber'].touched &&
                  userProfileForm.controls['mobileNumber'].errors
                    ?.mobileNumberValidation
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['mobileNumber'].touched &&
                        userProfileForm.controls['mobileNumber'].errors
                          ?.mobileNumberValidation
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>Country</mat-label>
                <input
                  matInput
                  formControlName="country"
                  placeholder="Country"
                  required
                />
                @if (
                  userProfileForm.controls['country'].touched &&
                  userProfileForm.controls['country'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      userProfileForm.controls['country'].touched &&
                        userProfileForm.controls['country'].errors
                          ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>State</mat-label>
                <input
                  matInput
                  formControlName="state"
                  placeholder="State"
                  required
                />
                @if (
                  userProfileForm.controls['state'].touched &&
                  userProfileForm.controls['state'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error
                    >{{
                      userProfileForm.controls['state'].touched &&
                        userProfileForm.controls['state'].errors
                          ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline">
                <mat-label>User Role</mat-label>

                <input
                  matInput
                  formControlName="userRole"
                  placeholder="User Role"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <div class="component-footer">
        <div class="button-group">
          <button class="edit-button" (click)="validateFormUpdate()">
            Update <mat-icon class="btn-icon">edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="custom-container">
    <div class="custom-modal custom-modal-s" id="changePassword">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Change Password</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeModal()"
            >
              &times;
            </button>
          </div>
          <form [formGroup]="userChangePasswordForm" novalidate>
            <div class="custom-modal-body">
              <div class="component-container">
                <div class="component-body">
                  <div class="form-section">
                    <div class="form-group">
                      <mat-form-field appearance="outline">
                        <mat-icon matPrefix>lock</mat-icon>
                        <mat-label>Current Password</mat-label>
                        <input
                          matInput
                          [type]="showCurrentPassword ? 'text' : 'password'"
                          formControlName="currentPassword"
                          placeholder="  Enter Current password"
                          autocomplete="current-password"
                          required
                        />
                        <button
                          matSuffix
                          class="primary-button"
                          (click)="showCurrentPassword = !showCurrentPassword"
                        >
                          <mat-icon>{{
                            showCurrentPassword
                              ? 'visibility_off'
                              : 'visibility'
                          }}</mat-icon>
                        </button>
                        @if (
                          userChangePasswordForm.controls['currentPassword']
                            .touched &&
                          userChangePasswordForm.controls['currentPassword']
                            .errors?.requiredAndNoEmptySpaces
                        ) {
                          <mat-error>
                            {{
                              userChangePasswordForm.controls['currentPassword']
                                .errors?.requiredAndNoEmptySpaces
                            }}
                          </mat-error>
                        } @else if (
                          userChangePasswordForm.controls['currentPassword']
                            .touched &&
                          userChangePasswordForm.controls['currentPassword']
                            .errors?.minLengthRequired
                        ) {
                          <mat-error>
                            {{
                              userChangePasswordForm.controls['currentPassword']
                                .errors?.minLengthRequired
                            }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                      <mat-form-field appearance="outline">
                        <mat-icon matPrefix>lock</mat-icon>
                        <mat-label>New Password</mat-label>
                        <input
                          matInput
                          [type]="showNewPassword ? 'text' : 'password'"
                          formControlName="newPassword"
                          placeholder="   Enter New Password"
                          autocomplete="current-password"
                          required
                        />
                        <button
                          matSuffix
                          class="primary-button"
                          (click)="showNewPassword = !showNewPassword"
                        >
                          <mat-icon>{{
                            showNewPassword ? 'visibility_off' : 'visibility'
                          }}</mat-icon>
                        </button>
                        @if (
                          userChangePasswordForm.controls['newPassword']
                            .touched &&
                          userChangePasswordForm.controls['newPassword'].errors
                            ?.requiredAndNoEmptySpaces
                        ) {
                          <mat-error>
                            {{
                              userChangePasswordForm.controls['newPassword']
                                .errors?.requiredAndNoEmptySpaces
                            }}
                          </mat-error>
                        } @else if (
                          userChangePasswordForm.controls['newPassword']
                            .touched &&
                          userChangePasswordForm.controls['newPassword'].errors
                            ?.minLengthRequired
                        ) {
                          <mat-error>
                            {{
                              userChangePasswordForm.controls['newPassword']
                                .errors?.minLengthRequired
                            }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Separator between Body and Footer -->
              <div class="component-separator"></div>

              <div class="component-footer">
                <div class="button-group">
                  <button
                    type="button"
                    class="submit-button"
                    (click)="validateFormPasswordUpdate()"
                  >
                    Change Password
                    <mat-icon class="btn-icon">check_circle</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
